import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { apiKeyRepository } from '@/lib/container'
import { useAuthStore } from '@/store/authStore'

export function useApiKeys() {
  const tenant = useAuthStore((s) => s.tenant)
  const qc = useQueryClient()

  const { data: apiKeys = [], isLoading } = useQuery({
    queryKey: ['api-keys', tenant?.id],
    queryFn: () => apiKeyRepository.findByTenantId(tenant!.id),
    enabled: !!tenant?.id,
  })

  const createMutation = useMutation({
    mutationFn: ({ name, scopes }: { name: string; scopes: string[] }) =>
      apiKeyRepository.create(tenant!.id, name, scopes),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-keys', tenant?.id] }),
  })

  const deleteMutation = useMutation({
    mutationFn: (id: string) => apiKeyRepository.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['api-keys', tenant?.id] }),
  })

  return {
    apiKeys,
    isLoading,
    createApiKey: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    deleteApiKey: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
  }
}
